import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex: 1 1 auto;\n  margin: ', 'px 6px;\n  white-space: nowrap;\n'], ['\n  align-items: center;\n  display: flex;\n  flex: 1 1 auto;\n  margin: ', 'px 6px;\n  white-space: nowrap;\n']);

import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme';

var Content = styled.div(_templateObject, gridSize);

Content.displayName = 'SingleSelectContent';

export default Content;